import type { MasterOption } from '@/api/masterData.api';

export function formatCountryOption(option: MasterOption): string {
  return `${option.label} (${option.code})`;
}

export function formatCurrencyOption(option: MasterOption): string {
  return option.extra ? `${option.label} (${option.code}) · ${option.extra}` : `${option.label} (${option.code})`;
}

export function formatTimezoneOption(option: MasterOption): string {
  return `${option.label} (${option.code})`;
}

export function countryLabelFromOptions(options: MasterOption[], code: string): string {
  const match = options.find((c) => c.code === code);
  return match ? formatCountryOption(match) : code;
}
